import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { useCallbackOne as useCallback } from 'use-memo-one';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
export var invokeExtensionMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmutation forge_ui_invokeExtension($input: InvokeExtensionInput!) {\n\t\tinvokeExtension(input: $input) {\n\t\t\tsuccess\n\t\t\tresponse {\n\t\t\t\tbody\n\t\t\t}\n\t\t\tcontextToken {\n\t\t\t\tjwt\n\t\t\t\texpiresAt\n\t\t\t}\n\t\t\terrors {\n\t\t\t\tmessage\n\t\t\t\textensions {\n\t\t\t\t\terrorType\n\t\t\t\t\tstatusCode\n\t\t\t\t\t... on InvokeExtensionPayloadErrorExtension {\n\t\t\t\t\t\tfields {\n\t\t\t\t\t\t\tauthInfoUrl\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])));
export var useInvokeExtension = function useInvokeExtension(contextIds, extensionId, options) {
  var _useMutation = useMutation(invokeExtensionMutation, options),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    mutationFunction = _useMutation2[0];
  return useCallback(function (payload) {
    var entryPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'resolver';
    return mutationFunction({
      variables: {
        input: {
          contextIds: contextIds,
          extensionId: extensionId,
          payload: payload,
          entryPoint: entryPoint
        }
      }
    });
  }, [contextIds, extensionId, mutationFunction]);
};